import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dropup d-inline-block" }
const _hoisted_2 = { class: "dropdown-menu" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("button", {
      class: "btn btn-success dropdown-toggle",
      type: "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, " Solve shortfalls ", -1)),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          class: "dropdown-item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('solve-take-less'))),
          disabled: _ctx.disableButtons
        }, " Take less ", 8, _hoisted_3)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          class: "dropdown-item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('solve-pay-more'))),
          disabled: _ctx.disableButtons || !_ctx.hasPensionPots
        }, " Pay more ", 8, _hoisted_4)
      ]),
      _createElementVNode("li", null, [
        (_ctx.equityReleaseEnabled)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "dropdown-item",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('solve-equity-release'))),
              disabled: _ctx.disableButtons
            }, " Home equity ", 8, _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}